module.exports = __webpack_public_path__ + "img/desktop-neck-9_442x18.549344b1.png";